import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    ContainerButtons,
    ModalContainer,
    Title
} from './styled';
import {
    ExpandButton,
    Modal
} from 'mol-ui';

const ConfirmationModal = ({
    actionHandler,
    active,
    cancelText,
    confirmText,
    loading = false,
    title,
    width
}) => {

    const { t } = useTranslation();

    return (
        <Modal active={ active } width={ width || '550px' } onToggle={ () => actionHandler('cancel') }>
            <ModalContainer>
                <Title>{ title }</Title>
                <ContainerButtons>
                    <ExpandButton
                        danger
                        caption={ cancelText ? cancelText : t('Cancelar') }
                        size={ 120 }
                        onClick={ () => actionHandler('cancel') }
                    />
                    <ExpandButton
                        caption={ confirmText ? confirmText : t('Confirmar') }
                        loading={ loading }
                        size={ 120 }
                        onClick={ () => actionHandler('confirm') }
                    />
                </ContainerButtons>
            </ModalContainer>
        </Modal>
    );
};

ConfirmationModal.propTypes = {
    actionHandler: PropTypes.func,
    active: PropTypes.bool,
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
    loading: PropTypes.bool,
    title: PropTypes.string,
    width: PropTypes.string
};

export default ConfirmationModal;
